import { render, staticRenderFns } from "./VesselFlagInput.vue?vue&type=template&id=05d23104&"
import script from "./VesselFlagInput.vue?vue&type=script&lang=js&"
export * from "./VesselFlagInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports